import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { TAG_PAGE_NAME } from '../../constants/service/app/tagConstants';
import TagGroupListContainer from '../../containers/tag/TagGroupListContainer';

const TagGroupList = () => {
  return (
    <PageTemplate pageName={TAG_PAGE_NAME.TAG_GROUP_LIST}>
      <TagGroupListContainer />
    </PageTemplate>
  );
};

export default TagGroupList;
